import type { GroupedProducts } from './groupProducts'
import { moveFocus } from './moveFocus'
import type { SalesPole } from './poles'

interface UseProductPanelParams {
  products: GroupedProducts
  activeTab: string
  searchValue: string
  setSearchValue: (value: string) => void
  poles: SalesPole[]
  pole: SalesPole | null
}

const useProductPanel = ({ products, activeTab, searchValue, setSearchValue, poles, pole }: UseProductPanelParams) => {
  const { main, secondary, leads } = products
  const hasPoles = poles.length > 0

  return {
    main,
    secondary,
    leads,
    hasPoles,
    isSearching: searchValue.length > 0,
    isWaitingForPole: hasPoles && !pole,
    hasProducts: main.length + secondary.length + leads.length > 0,
    hasLeads: leads.length > 0,
    secondaryKey: `secondary-${pole?.id ?? ''}`,
    isSecondaryOpen: secondary.includes(activeTab),
    onPanelKeyDown: moveFocus('[id^="tab-"]'),
    onSearchChange: (value: string | null) => setSearchValue(value ?? ''),
  }
}

export default useProductPanel
